import type { ProductLogoSmallProps } from '../types';

export function ProductLogoSmallStarlinks({
  size = 20,
  color = '#1874A1',
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 480 480"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M158.123 224.814C151.874 218.565 151.874 208.435 158.123 202.186L203.378 156.932C209.626 150.683 219.757 150.683 226.005 156.932L305.201 236.128C311.449 242.376 311.449 252.507 305.201 258.755L259.946 304.01C253.698 310.258 243.567 310.258 237.319 304.01L158.123 224.814Z"
        fill={color}
      />
      <path
        d="M165.901 275.018L187.114 253.805L208.327 275.018L187.114 296.232L165.901 275.018Z"
        fill={color}
      />
      <path
        d="M254.997 185.923L276.21 164.71L297.423 185.923L276.21 207.136L254.997 185.923Z"
        fill={color}
      />
      <path
        d="M66.199 336.537L125.596 395.934L184.993 336.537L125.596 277.14L66.199 336.537ZM189.236 213.5L248.633 272.897L274.088 247.441L214.691 188.044L189.236 213.5ZM278.331 124.405L337.728 183.802L397.125 124.405L337.728 65.0077L278.331 124.405ZM349.042 214.914C342.793 221.163 332.663 221.163 326.414 214.914L297.423 185.923L276.21 207.136L305.201 236.128C311.449 242.376 311.449 252.507 305.201 258.755L259.946 304.01C253.698 310.258 243.567 310.258 237.319 304.01L208.327 275.018L187.114 296.232L216.106 325.223C222.354 331.471 222.354 341.602 216.106 347.85L136.91 427.046C130.661 433.295 120.531 433.295 114.282 427.046L35.0863 347.85C28.8379 341.602 28.8379 331.471 35.0863 325.223L114.282 246.027C120.531 239.779 130.661 239.779 136.91 246.027L165.901 275.018L187.114 253.805L158.123 224.814C151.874 218.565 151.874 208.435 158.123 202.186L203.378 156.932C209.528 150.781 219.441 150.684 225.71 156.643L226.005 156.932L254.997 185.923L276.21 164.71L247.218 135.718C240.97 129.47 240.97 119.339 247.218 113.091L326.414 33.895C332.663 27.6466 342.793 27.6466 349.042 33.895L428.238 113.091C434.486 119.339 434.486 129.47 428.238 135.718L349.042 214.914Z"
        fill={color}
      />
      <path
        d="M337.88 292.69C337.88 286.063 343.253 280.69 349.88 280.69C356.508 280.69 361.88 286.063 361.88 292.69C361.88 302.145 360.018 311.508 356.4 320.243C352.782 328.978 347.478 336.916 340.793 343.602C334.107 350.288 326.169 355.591 317.433 359.21C308.698 362.828 299.335 364.69 289.88 364.69C283.253 364.69 277.88 359.318 277.88 352.69C277.88 346.063 283.253 340.69 289.88 340.69C296.184 340.69 302.426 339.449 308.25 337.037C314.073 334.625 319.365 331.089 323.822 326.632C328.279 322.174 331.815 316.883 334.227 311.059C336.639 305.236 337.88 298.994 337.88 292.69Z"
        fill={color}
      />
      <path
        d="M397.776 292.586C397.776 285.959 403.149 280.586 409.776 280.586C416.404 280.586 421.776 285.959 421.776 292.586C421.776 309.92 418.362 327.086 411.728 343.101C405.095 359.115 395.371 373.667 383.114 385.924C370.857 398.181 356.306 407.904 340.291 414.538C324.276 421.172 307.111 424.586 289.776 424.586C283.149 424.586 277.776 419.213 277.776 412.586C277.776 405.959 283.149 400.586 289.776 400.586C303.959 400.586 318.003 397.793 331.106 392.365C344.209 386.938 356.115 378.982 366.143 368.953C376.172 358.924 384.128 347.019 389.556 333.916C394.983 320.813 397.776 306.769 397.776 292.586Z"
        fill={color}
      />
    </svg>
  );
}
